
import React from 'react';
import { Target, Users, Award } from 'lucide-react';

const MissionSection = () => {
  return (
    <section className="bg-brand-gray section">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Onze missie</h2>
          <p className="section-subtitle mx-auto max-w-3xl">
            We geloven dat elke groeigerichte onderneming in België het verdient om te groeien zonder stress over klantenwerving.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="p-6 bg-white rounded-lg shadow-sm text-center">
            <div className="text-brand-blue mb-4 mx-auto">
              <Target size={36} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Onze missie</h3>
            <p className="text-gray-600">
              B2B-organisaties helpen groeien door hun agenda te vullen met relevante afspraken, zodat ze zich kunnen focussen op hun kernactiviteiten.
            </p>
          </div>
          
          <div className="p-6 bg-white rounded-lg shadow-sm text-center">
            <div className="text-brand-blue mb-4 mx-auto">
              <Users size={36} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Onze doelgroep</h3>
            <p className="text-gray-600">
              KMO's, middelgrote organisaties én enterprises die structurele commerciële slagkracht nodig hebben en hun salesproces willen professionaliseren.
            </p>
          </div>
          
          <div className="p-6 bg-white rounded-lg shadow-sm text-center">
            <div className="text-brand-blue mb-4 mx-auto">
              <Award size={36} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Onze belofte</h3>
            <p className="text-gray-600">
              Concrete resultaten leveren met meetbare impact op je omzet, zonder loze beloftes of langdurige contracten.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
